import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ItemsDropDownDto } from './items-drop-down.dto';


export class ItemsDetailsResponseModel extends GlobalResponseObject {
    data?: ItemsDropDownDto[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data /ItemsDropDownDto[]
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: ItemsDropDownDto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

 